/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
export function bindWindowEvents (window, eventBus) {
  window.postToParent = window.postToParent || function (data) {
    if (window.nativeTransport) {
      window.nativeTransport(data);
    } else if (parent && parent !== window) {
      try {
        parent.postMessage(data, '*'); // NOSONAR
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.log('PostToParent exception', ex);
      }
    }
  };

  window.addEventListener('message', event => {
    switch (event.data.type) {
      case 'loginsuccess': {
        let info = {};
        if (event.data.info) {
          info = {
            token: event.data.info.token,
            lang: event.data.info.lang,
            bandwidth: event.data.info.bandwidth
          };
        }
        eventBus.$emit('window-loginSuccess', info, { root: true });
        break;
      }
      case 'loginerror':
        if (event.data.msg) {
          eventBus.$emit(
            'window-loginError',
            {
              msg: event.data.msg
            },
            { root: true }
          );
        }
        break;
      case 'pinresetsuccess':
        eventBus.$emit('window-pinresetsuccess', {}, { root: true });
        break;
      case 'pinreseterror':
        eventBus.$emit('window-pinreseterror', {}, { root: true });
        break;
      case 'joinmeeting':
        eventBus.$emit('goto-webrtc-page-deeplink', event.data.data, { root: true });
        window.postToParent({
          type: 'clearroom'
        });
        break;
      case 'oauthcode': {
        const oauthcode = event.data.oauthcode || (event.data.data && event.data.data.oauthcode);
        eventBus.$emit('native-onAuthenticateUser', oauthcode, { root: true });
        break;
      }
    }
  });
}
